import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const SalesSupervisorsOrderDetails = () => {
  const [view, setView] = useState('current'); // Toggle between current and past orders
  const [orders, setOrders] = useState([]); // State to store transactions
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  const user = JSON.parse(localStorage.getItem('user'));
  const email = user.email;

  useEffect(() => {
    // Fetch transactions from the backend
    const fetchTransactions = async () => {
      try {
        const response = await axios.post(`https://citi-mobile-app.onrender.com/admin/fetch-transactions/${email}`);
        setOrders(response.data.transactions); // Set transactions in state
        setLoading(false);
        console.log('Fetched transactions:', response.data.transactions); // Debugging: log fetched transactions
      } catch (err) {
        console.log('Error fetching transactions:', err);
        setError('Failed to fetch transactions');
        setLoading(false);
      }
    };

    if (email) {
      fetchTransactions();
    }
  }, [email]);

  if (loading) {
    return <div>Loading...</div>; // Show loading spinner
  }

  if (error) {
    return <div>{error}</div>; // Show error message if something goes wrong
  }

  // Filter current and past orders based on order status
  const currentOrders = orders.filter(order => order.deliverystatus === 'processing');
  const pastOrders = orders.filter(order => 
    order.deliverystatus.toLowerCase() === 'delivered'
  );

  // Debugging: log filtered orders
  console.log('Current orders:', currentOrders);
  console.log('Past orders:', pastOrders);

  return (
    <div className="max-w-[85%] mt-20 ml-60 max-sm:ml-0 max-sm:w-screen">
      {/* Toggle buttons */}
      <div className="flex justify-end space-x-4 mb-8">
        <button
          onClick={() => setView('current')}
          className={`px-4 py-2 rounded ${view === 'current' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'}`}
        >
          Current Orders
        </button>
        <button
          onClick={() => setView('past')}
          className={`px-4 py-2 rounded ${view === 'past' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'}`}
        >
          Past Orders
        </button>
      </div>

      {/* Scrollable Order Table */}
      <div className="overflow-x-auto w-[100%] overflow-y-auto max-h-96 shadow-md bg-white p-3 rounded-md">
      <h3 className="text-lg font-semibold mb-4">Sales Agent Performance Table</h3>

        <table className="w-[100%]">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">No</th>
              <th className="px-4 py-2 text-left">Order Number/ID</th>
              <th className="px-4 py-2 text-left">Customer Name</th>
              <th className="px-4 py-2 text-left">Order Date</th>
              <th className="px-4 py-2 text-left">Order Status</th>
              <th className="px-4 py-2 text-left">Total Amount</th>
              <th className="px-4 py-2 text-left">Payment Status</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {/* Display Current Orders */}
            {view === 'current' &&
              currentOrders.map((order, index) => (
                <tr key={order._id} className="border-b">
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{order._id}</td>
                  <td className="px-4 py-2">{order.fullname}</td>
                  <td className="px-4 py-2">{new Date(order.date).toLocaleDateString()}</td>
                  <td className="px-4 py-2">
                    <span className="bg-orange-100 text-orange-600 py-1 px-3 rounded-full text-sm">
                      {order.deliverystatus}
                    </span>
                  </td>
                  <td className="px-4 py-2">{order.totalAmount}</td>
                  <td className="px-4 py-2">
                    <span className={`${
                      order.paymentstatus === 'Paid' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                    } py-1 px-3 rounded-full text-sm`}>
                      {order.paymentstatus}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <Link to={`/SalesSupervisorsOrderDetails/SalesSupervisorOrderSummary/${order._id}`} className="text-blue-600">View more</Link>
                  </td>
                </tr>
              ))
            }

            {/* Display Past Orders */}
            {view === 'past' &&
              pastOrders.map((order, index) => (
                <tr key={order._id} className="border-b">
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{order._id}</td>
                  <td className="px-4 py-2">{order.fullname}</td>
                  <td className="px-4 py-2">{new Date(order.date).toLocaleDateString()}</td>
                  <td className="px-4 py-2">
                    <span className="bg-green-100 text-green-600 py-1 px-3 rounded-full text-sm">
                      {order.deliverystatus}
                    </span>
                  </td>
                  <td className="px-4 py-2">{order.totalAmount}</td>
                  <td className="px-4 py-2">
                    <span className={`${
                      order.paymentstatus === 'Paid' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                    } py-1 px-3 rounded-full text-sm`}>
                      {order.paymentstatus}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <Link to={`/SalesSupervisorsOrderDetails/SalesSupervisorOrderSummary/${order._id}`} className="text-blue-600">View more</Link>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalesSupervisorsOrderDetails;
